import styled from "styled-components";

export const MenteeMatchModalTitle = styled.div`
    color: #302F2F;
    text-align: center;
    font-family: "Nunito Sans";
    font-size: 18px;
    font-weight: 500;
    padding: 120px 0 20px 0;
`;

export const SuccessIcon = styled.div`
    display:flex;
    justify-content:center;
    align-items: center;
    margin: 30px auto 35px auto;
    border-radius:50%;
    display: flex;
    width: 47px;
    height: 47px;
    gap: 11.75px;
    position:absolute;
    top:30px;
    left:0;
    right:0;
`;